import { DEFAULT_STORE_OBJECT } from '@/redux/constants';
import type { DefaultStoreObject } from '@/redux/types';
import type { ProcurementLane } from '@/views/screens/Procurement';
import { v4 as uuidv4 } from 'uuid';
import ProcurementLaneType from './ProcurementLaneTypes';
import getLaneList from './requestPayload/GetLaneBy';

export interface ProcurementLaneState extends Record<string, any> {
  selectedLaneListItems: ProcurementLane[];
  setAddNewLaneData: {
    btnClicked: boolean;
  };
  laneList: DefaultStoreObject<ProcurementLane[]> & {
    totalRecord: number;
  };
}

const initialState: ProcurementLaneState = {
  laneList: {
    ...DEFAULT_STORE_OBJECT,
    data: [],
    totalRecord: 0,
  },
  laneListReq: {
    ...getLaneList,
  },
  setAddNewLaneData: {
    btnClicked: false,
  },
  selectedLaneListItems: [],
};

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
const ProcurementLaneReducer = (state = initialState, { type, payload }: any): ProcurementLaneState => {
  switch (type) {
    case ProcurementLaneType.SELECTED_LANE_LIST: {
      return {
        ...state,
        selectedLaneListItems: payload,
      };
    }
    case ProcurementLaneType.GET_PROCUREMENT_LANE_LIST: {
      return {
        ...state,
        laneList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.laneList,
          progressing: true,
        },
      };
    }

    case ProcurementLaneType.GET_PROCUREMENT_LANE_LIST_SUCCESS: {
      // @ts-ignore
      payload.data.data.forEach((element) => {
        element.isSelected = false;
        if (element?.originDetailsItems?.[0]) element.originDetailsItems[0].locationId = element.originId;
        if (element.destinationDetailsItems?.[0]) element.destinationDetailsItems[0].locationId = element.destinationId;
      });

      return {
        ...state,
        laneList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.laneList,
          success: true,
          data: [...(state.laneList.data || []), ...payload.data.data],
          progressing: false,
          totalRecord: payload.data.total,
        },
      };
    }

    case ProcurementLaneType.GET_PROCUREMENT_LANE_LIST_FAIL: {
      return {
        ...state,
        laneList: {
          ...DEFAULT_STORE_OBJECT,
          ...state.laneList,
          error: true,
          data: payload.data,
          progressing: false,
          totalRecord: 0,
        },
      };
    }

    case ProcurementLaneType.SET_PROCUREMENT_LANE_LIST_REQUEST: {
      if (payload === 'removeNewRecords') {
        state.laneList?.data?.shift();
        return {
          ...state,
          setAddNewLaneData: {
            btnClicked: false,
          },
          laneList: {
            ...state.zoneList,
            data: state.laneList?.data,
          },
        };
      }
      if (payload === 'reset') {
        return {
          ...state,
          setAddNewLaneData: {
            btnClicked: false,
          },
          laneListReq: {
            ...getLaneList,
          },
          laneList: {
            ...state.laneList,
            data: [],
          },
        };
      }
      return {
        ...state,
        laneListReq: {
          ...state.laneListReq,
          ...payload,
        },
      };
    }

    case ProcurementLaneType.RESET_PROCUREMENT_LANE_LIST: {
      return {
        ...state,
        laneList: {
          ...state.laneList,
          data: [],
        },
      };
    }

    case ProcurementLaneType.SET_ADD_NEW_LANE: {
      let stateValue = {
        ...state,
        setAddNewLaneData: {
          btnClicked: payload.btnClicked,
        },
      };
      if (payload?.add === true) {
        stateValue = {
          ...stateValue,
          laneList: {
            ...state.laneList,
            data: [
              // @ts-ignore
              {
                isNew: true,
                renderKey: uuidv4(),
                originDetailsItems: [],
                destinationDetailsItems: [],
              },
              ...(state.laneList.data || []),
            ],
          },
        };
      }
      if (payload?.remove === true) {
        const removeItem = state.laneList.data?.slice(1);
        stateValue = {
          ...stateValue,
          laneList: {
            ...state.laneList,
            data: [...(removeItem || [])],
          },
        };
      }
      return stateValue;
    }

    default:
      return state;
  }
};

export default ProcurementLaneReducer;
